import { render, staticRenderFns } from "./configFeeSummary.vue?vue&type=template&id=9bb71656&scoped=true"
import script from "./configFeeSummary.vue?vue&type=script&lang=js"
export * from "./configFeeSummary.vue?vue&type=script&lang=js"
import style0 from "./configFeeSummary.vue?vue&type=style&index=0&id=9bb71656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb71656",
  null
  
)

export default component.exports